import * as utils from 'app/utils'
import * as config from 'config'
import { IHelpfulVideo } from 'config/interfaces'
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'
import { Alert, Button, ButtonGroup, Col, FormGroup, Modal, ModalBody, Panel, Row } from 'react-bootstrap'

interface IHelpfulVideoProps {
  info: IHelpfulVideo,
  onClose?: () => void
}

interface IHelpfulVideoState {
  isShowing: boolean
}

class HelpfulVideo extends React.Component<IHelpfulVideoProps, IHelpfulVideoState> {
  state = {
    isShowing: true
  }

  renderVideo(url: string, width: number, height: number) {
    // add a 'rel=0' quesrystring param to disable related videos from showing
    const sep = (url.indexOf('?') < 0) ? '?' : '&'
    url = url + sep + 'rel=0'
    const html5Markup =  <iframe src={url}
      style={{ position: 'absolute', width: '100%', height: '100%', left: 0 }}
      width={width} height={height}
      frameBorder={0}
      allowFullScreen />
    const IEMarkup = <object width={width} height={height} data={url}></object>
    return utils.isInternetExplorer() ? IEMarkup : html5Markup
  }

  render() {
    if (!this.props.info) { return null }
    return <Modal show={true}
      onHide={() => {
        this.setState({ isShowing: false })
        if (this.props.onClose) { this.props.onClose() }
      }}
      className="introVideo modal-transparent">
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body style={{ width: 'auto', height: 554, padding: 0 }}>
        {this.renderVideo(this.props.info.url, 886, 554)}
      </Modal.Body>
    </Modal>
  }
}

export {
  HelpfulVideo
}



// WEBPACK FOOTER //
// ./src/app/components/HelpfulVideo/index.tsx